// import React, { useEffect, useRef, useState } from 'react'
// import axiosInstance from '../../../../Services/axiosCommon';
// import { useFormik } from 'formik';
// import { useToast } from '../../../../Components/Others/ToastServices';
// import { useLocation, useParams } from 'react-router-dom';
// import * as yup from 'yup';
// import ModalContainer from '../../../../Components/Others/ModalContainer';
// import SendOTP from './SendOTP';
// import {BackButton, SubmitButton } from '../../../../Components/Utils/Buttons';
// import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
// import NewCommonDynamicForm from '../../../../Components/Utils/NewCommonDynamicForm';
// import { GetAccess, GetRole } from '../../../../Components/Utils/roles';
// import EditIcon from '../../../../Components/Icons/Edit';

// function FormOpen() {
//      const collectorSign = useRef(null);
//   const clientSign = useRef(null);

//   const [collectorDataURL, setCollectorDataURL] = useState(null);
//   const [clientDataURL, setClientDataURL] = useState(null);

//   const [isCollectorSignEnabled, setIsCollectorSignEnabled] = useState(false);
//   const [isClientSignEnabled, setIsClientSignEnabled] = useState(false);
//   const [signOne, setSignOne] = useState(null);
//   const [signTwo, setSignTwo] = useState(null);
//   const [filesList, setFileList] = useState([]);
//   const [removeSignOne, setRemoveSignOne] = useState("");
//   const [removeSignTwo, setRemoveSignTwo] = useState("");
//   const [showActionButtons, setShowActionButtons] = useState(false);
//   const [showClientActionButtons, setShowClientActionButtons] = useState(false);
//   const { scheduleViewId } = useParams();
//   const [editModeIndex, setEditModeIndex] = useState(null);
//      const location = useLocation();

// const form = location.state?.form;
// console.log(form,'form');

//   const toast = useToast();

//   const [allFormValues, setAllFormValues] = useState([]);
//   const [allForm, setAllForm] = useState([]);
//   const [allValue, setAllValue] = useState([]);
//   const [isSubmittted, setisSubmittted] = useState(false);
//   const [fileRemoveList, setFileRemoveList] = useState([]);
//   useEffect(() => {

//     if (scheduleViewId)
//     fetchAllForm(scheduleViewId);

//         fetchTasks(scheduleViewId);

//   }, [scheduleViewId]);

//   const fetchTasks = async (value) => {
//     try {
//       // setLoading(true);
//       const response = await axiosInstance.get(`/schedules/forms/${value}`);
//       console.log("Form ID", response.data?.data);
//       const Data = response.data?.data;
//       setisSubmittted(response?.data?.isSubmitted === false);
//       setAllFormValues(Data);
//       checkAllSubmitted();
//       checkOtpEnable();
//     } catch (error) {
//       console.error("Error fetching tasks:", error);
//     } finally {
//       // setLoading(false);
//     }
//   };

//   const [formId, setFormId] = useState(null);

//   const fetchAllForm = async (value) => {
//     setFormId(value);
//     try {
//       // setLoading(true);
//       const formResponse = await axiosInstance.get(
//         `/schedules/form-fields/${value}`
//       );
//       console.log(formResponse.data?.data);
//       setAllForm(formResponse.data?.data);
//       let TempArray = [];
//       let tempFormData = formResponse.data?.data?.titles || [];
//       tempFormData?.forEach((item) => {
//         item?.fields?.forEach((field) => {
//           console.log("Field - getting", field);
//           let ValueInSide = {
//             id: field?.id,
//             field_type: field?.field_type,
//             field_label: field?.field_label,
//             value: field?.value,
//           };
//           TempArray.push(ValueInSide);
//         });
//       });
//       setAllValue(TempArray);
//     } catch (error) {
//       console.error("Error fetching tasks:", error);
//     } finally {
//       // setLoading(false);
//     }
//   };

//   const [expandedIndex, setExpandedIndex] = useState(null);
//   const [showErrorFeild, setShowErrorFeild] = useState(false);
//   const [ErrorMessage, setErrorMessage] = useState("");

//   const handleToggle = (index, id) => {
//     setAllForm([]);
//     fetchAllForm(id);
//     setExpandedIndex(index === expandedIndex ? null : index);
//   };

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: {},
//     validationSchema: yup.object({}),
//     validateOnChange: false,
//     validateOnBlur: false,
//     onSubmit: (values) => {
//       let ValuesForForm = {
//         isSubmitted: true,
//         values: allValue,
//         filesToRemove: [],
//         oldSign1: removeSignOne || "",
//         oldSign2: removeSignTwo || "",
//       };
//       let formData = new FormData();
//       formData.append("json_data", JSON.stringify(ValuesForForm));
//       filesList &&
//         filesList.map((item) => {
//           formData.append("attachments", item);
//         });
//       signOne &&
//         formData.append(
//           "signature1",
//           signOne,
//           `signature1-${formId}-${new Date().toISOString()}.png`
//         );
//       signTwo &&
//         formData.append(
//           "signature2",
//           signTwo,
//           `signature2-${formId}-${new Date().toISOString()}.png`
//         );
//       axiosInstance
//         .put(`/schedules/form-submition/${formId}`, formData)
//         .then((res) => {
//           console.log("Form Submitted", res.data);
//           if (res.data?.status === true) {
//             toast.open({
//               type: "success",
//               message: "Success",
//               description: res.data?.msg || "Created Successfully.",
//             });
//             CloseEditForm(formId);
//           } else {
//             toast.open({
//               type: "error",
//               message: "Error",
//               description: res.data?.msg || "Network error.",
//             });
//             setShowErrorFeild(true);
//             setErrorMessage(res.data?.data || "Network error.");
//           }
//         })
//         .catch((error) => {
//           toast.open({
//             type: "error",
//             message: "Error",
//             description: error?.response?.data?.msg || "Network error.",
//           });
//         });
//     },
//   });

//   function SaveFormData() {
//     let ValuesForForm = {
//       isSubmitted: false,
//       values: allValue,
//       filesToRemove: [],
//       oldSign1: removeSignOne || "",
//       oldSign2: removeSignTwo || "",
//     };
//     let formData = new FormData();
//     formData.append("json_data", JSON.stringify(ValuesForForm));
//     filesList &&
//       filesList.map((item) => {
//         formData.append("attachments", item);
//       });
//     signOne &&
//       formData.append(
//         "signature1",
//         signOne,
//         `signature1-${formId}-${new Date().toISOString()}.png`
//       );
//     signTwo &&
//       formData.append(
//         "signature2",
//         signTwo,
//         `signature2-${formId}-${new Date().toISOString()}.png`
//       );

//     axiosInstance
//       .put(`/schedules/form-submition/${formId}`, formData)
//       .then((res) => {
//         if (res.data?.status === true) {
//           toast.open({
//             type: "success",
//             message: "Success",
//             description: res.data?.msg || "Created Successfully.",
//           });
//           CloseEditForm(formId);
//         } else {
//           toast.open({
//             type: "error",
//             message: "Error",
//             description: res.data?.msg || "Network error.",
//           });
//         }
//       })
//       .catch((error) => {
//         toast.open({
//           type: "error",
//           message: "Error",
//           description: error?.response?.data?.msg || "Network error.",
//         });
//       });
//   }

//   async function CloseEditForm(formId) {
//   try {
//     const res = await axiosInstance.put(`/schedules/close-form/${formId}`);
//     if (res?.data?.status) {
//       setEditModeIndex(null);
//       fetchTasks(formId);
//     } else {
//       toast.open({
//         type: "error",
//         message: "Error",
//         description: res.data?.msg || "Network error.",
//       });
//     }
//   } catch (error) {
//     toast.open({
//       type: "error",
//       message: "Error",
//       description: error?.response?.data?.msg || "Network error.",
//     });
//   }
// }

//  async function OpenEditForm(formId, workingUser) {
//   if (workingUser) {
//     CloseEditForm(formId);
//   } else {
//     try {
//       const res = await axiosInstance.put(`/schedules/open-form/${formId}`);
//       if (res?.data?.status) {
//         fetchTasks(formId);
//         setEditModeIndex(formId); // Set edit mode to the form ID
//       } else {
//         toast.open({
//           type: "error",
//           message: "Error",
//           description: res.data?.msg || "Network error.",
//         });
//       }
//     } catch (error) {
//       toast.open({
//         type: "error",
//         message: "Error",
//         description: error?.response?.data?.msg || "Network error.",
//       });
//     }
//   }
// }
//   const [open, setOpen] = useState(false);

//   const handleSendOTP = () => setOpen(true);
//   const handleCloseModal = () => setOpen(false);
//   const [allSubmitted, setAllSubmitted] = useState(false);

//   const checkAllSubmitted = async () => {
//     try {
//       const response = await axiosInstance.get(
//         `/schedules/check-submitted/${scheduleViewId}`
//       );
//       console.log("Check Submitted Status", response.data);
//       // fetchTasks(scheduleViewId)

//       setAllSubmitted(response.data?.data === true);
//     } catch (error) {
//       console.error("Error checking submission status:", error);
//     }
//   };

//   useEffect(() => {
//     if (scheduleViewId) {
//       checkAllSubmitted();
//       fetchTasks(scheduleViewId);
//     }
//   }, [scheduleViewId]);
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (collectorSign.current) {
//         collectorSign.current.off();
//         clearInterval(interval);
//       }
//     }, 50);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (collectorSign.current) {
//       isCollectorSignEnabled
//         ? collectorSign.current.on()
//         : collectorSign.current.off();
//     }
//   }, [isCollectorSignEnabled]);

//   // Client
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (clientSign.current) {
//         clientSign.current.off();
//         clearInterval(interval);
//       }
//     }, 50);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (clientSign.current) {
//       isClientSignEnabled ? clientSign.current.on() : clientSign.current.off();
//     }
//   }, [isClientSignEnabled]);

//   const [otpEnable, setOtpEnable] = useState(false);

//   const [openEnable, setEnableOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Fetch OTP enable status
//   const checkOtpEnable = async () => {
//     try {
//       const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
//       console.log("Check Submitted Status", response.data);

//       if (response.data?.status) {
//         setOtpEnable(response.data.data === true);
//       } else {
//         console.warn("Unexpected response status:", response.data);
//         setOtpEnable(false);
//       }
//     } catch (error) {
//       console.error("Error checking submission status:", error);
//       setOtpEnable(false);
//     }
//   };

//   // On button click, open confirm popup
//   const handleEnableOTP = () => setEnableOpen(true);

//   // On confirm, call verify API
//   const handleVerifyOTP = () => {
//     setLoading(true);
//     axiosInstance
//       .put(`/schedules/verify-otp/${scheduleViewId}`, { opt: "" })
//       .then((res) => {
//         if (res.data.status) {
//           toast.open({
//             type: "success",
//             message: "OTP Verified",
//           });
//           fetchTasks(scheduleViewId);
//         } else {
//           toast.open({
//             type: "error",
//             message: "Invalid OTP",
//             description: res.data.msg,
//           });
//         }
//       })
//       .catch((err) => {
//         toast.open({
//           type: "error",
//           message: "Network Error",
//           description: err.message,
//         });
//       })
//       .finally(() => {
//         setLoading(false);
//         setEnableOpen(false);
//       });
//   };

//   // On page load, check status and fetch tasks
//   useEffect(() => {
//     checkOtpEnable();
//     fetchTasks(scheduleViewId);
//   }, [scheduleViewId]);

//   useEffect(() => {
//     if (allForm?.signature1?.file) {
//       setRemoveSignOne(allForm?.signature1?.file);
//     }
//     if (allForm?.signature2?.file) {
//       setRemoveSignTwo(allForm?.signature2?.file);
//     }
//   }, [allForm]);
//   return (
//     <>
//  <div className="py-4 px-4 overflow-hidden h-[calc(100vh-80px)] flex flex-col">
//  <div className="sm:flex justify-between w-full mb-4">
//   <Breadcrumb
//     items={[
//       {
//         name: "Form",
//         link: `/inspection/schedule/newform/${scheduleViewId}`
//       },
//       {
//       name: form?.formName || "Form Details",
//     },
//     ]}
//   />
//   <div className='flex gap-2 justify-end'>
//   {GetAccess("inspection_schedule_form_edit") && (GetRole() || isSubmittted) && (
//   <span
//     onClick={() => OpenEditForm(scheduleViewId, form?.workingUser)}
//     className={`cursor-pointer mr-4 rounded-md p-1 border
//       ${
//         editModeIndex === scheduleViewId
//           ? "bg-green-100 border-green-500"
//           : "bg-red-100 border-red-500"
//       }`}
//   >
//     <EditIcon
//       color={editModeIndex === scheduleViewId ? "green" : "red"}
//       height={16}
//     />
//   </span>
// )}
//   <BackButton />
// </div>
// </div>
//   <div className="bg-white flex-1 overflow-y-auto rounded-md ">
//     <form onSubmit={formik.handleSubmit}>
//       <NewCommonDynamicForm
//         formData={allForm?.titles || []}
//         formik={formik}
//         allValue={allValue}
//         setAllValue={setAllValue}
//         SaveFormData={SaveFormData}
//         editModeIndex={!!editModeIndex}
//         FileAttachment={setFileList}
//         SignOne="Inspector"
//         SignTwo="Client"
//         setSignFunOne={setSignOne}
//         setSignFunTwo={setSignTwo}
//         allData={allForm}
//         setFileRemoveList={setFileRemoveList}
//         fileRemoveList={fileRemoveList}
//         setRemoveSignOne={setRemoveSignOne}
//         setRemoveSignTwo={setRemoveSignTwo}
//       />
//     </form>

//     {/* {allSubmitted && isSubmittted && otpEnable && (
//       <div className="w-full p-4 flex justify-end">
//         <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
//       </div>
//     )}
//     {!otpEnable && isSubmittted && (
//       <div className="w-full p-4 flex justify-end">
//         <SubmitButton name="Verify" handleClick={handleEnableOTP} />
//       </div>
//     )} */}
//   </div>

//   {/* Modals */}
//   {/* {open && (
//     <SendOTP
//       scheduleViewId={scheduleViewId}
//       onClose={() => setOpen(false)}
//       fetchTasks={fetchTasks}
//     />
//   )}
//   {openEnable && (
//     <ModalContainer
//       visiable={openEnable}
//       title="Confirm"
//       content={
//         <div>
//           <p>
//             Are You Sure! You want to{" "}
//             <span className="font-semibold">Verify</span> this Form?
//           </p>
//         </div>
//       }
//       handleClick={handleVerifyOTP}
//       closeModal={() => setEnableOpen(false)}
//       isLoading={loading}
//     />
//   )} */}

//   {showErrorFeild && (
//     <ModalContainer
//       closeModal={() => setShowErrorFeild(false)}
//       visiable={showErrorFeild}
//       title=""
//       hasButton={false}
//       content={
//         <div className="max-w-[65vw] max-h-[90vh] min-h-[30vh] 2xl:min-w-[45vw]">
//           <div className="w-full h-7 mb-2 flex justify-between items-center">
//             <p className="font-semibold text-sm">Fields to be checked</p>
//             <div className="flex gap-4 items-center">
//               <button
//                 className="text-white bg-red-600"
//                 onClick={() => {
//                   setShowErrorFeild(false);
//                   setErrorMessage("");
//                 }}
//               >
//                 <svg
//                   className="w-6 h-6"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//           </div>
//           <div className="w-full max-h-[calc(90vh-32px)] overflow-y-auto">
//             <pre>{ErrorMessage}</pre>
//           </div>
//         </div>
//       }
//     />
//   )}
// </div>

//  </> )
// }

// export default FormOpen

import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import { useFormik } from "formik";
import { useToast } from "../../../../Components/Others/ToastServices";
import {
  useLocation,
  useParams,
  useNavigate,
  useNavigationType,
} from "react-router-dom";
import * as yup from "yup";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import SendOTP from "./SendOTP";
import { BackButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import NewCommonDynamicForm from "../../../../Components/Utils/NewCommonDynamicForm";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import EditIcon from "../../../../Components/Icons/Edit";

function FormOpen() {
  const collectorSign = useRef(null);
  const clientSign = useRef(null);
  const navigate = useNavigate();
  const navigationType = useNavigationType(); // Get navigation type
  const [isCollectorSignEnabled, setIsCollectorSignEnabled] = useState(false);
  const [isClientSignEnabled, setIsClientSignEnabled] = useState(false);
  const [signOne, setSignOne] = useState(null);
  const [signTwo, setSignTwo] = useState(null);
  const [filesList, setFileList] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");
  const { scheduleViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);
  const location = useLocation();

  const form = location.state?.form;

  const toast = useToast();

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState(false);
  const [fileRemoveList, setFileRemoveList] = useState([]);

  const [showNavigationConfirm, setShowNavigationConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [isClosingForm, setIsClosingForm] = useState(false);

  // Store the original navigate function
  const originalNavigate = useRef(navigate);

  useEffect(() => {
    if (scheduleViewId) {
      fetchAllForm(scheduleViewId);
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);

  // Override the navigate function to intercept all navigation
  useEffect(() => {
    const handleNavigation = (to, options) => {
      if (editModeIndex === scheduleViewId) {
        // Form is open, show confirmation
        setPendingNavigation({ to, options });
        setShowNavigationConfirm(true);
        return false; // Prevent navigation
      }
      // Form is not open, allow navigation
      return originalNavigate.current(to, options);
    };

    // Replace the navigate function
    navigate.replace = handleNavigation;
  }, [editModeIndex, scheduleViewId, navigate]);

  // Handle browser back button/refresh
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (editModeIndex === scheduleViewId) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    // Listen for click events on sidebar links
    const handleSidebarClick = (e) => {
      const link = e.target.closest("a[href]");
      if (link && editModeIndex === scheduleViewId) {
        e.preventDefault();
        setPendingNavigation(link.getAttribute("href"));
        setShowNavigationConfirm(true);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleSidebarClick);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleSidebarClick);
    };
  }, [editModeIndex, scheduleViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(`/schedules/forms/${value}`);
      const Data = response.data?.data;
      setisSubmittted(response?.data?.isSubmitted === false);
      setAllFormValues(Data);
      checkAllSubmitted();
      checkOtpEnable();
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      const formResponse = await axiosInstance.get(
        `/schedules/form-fields/${value}`
      );
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let ValuesForForm = {
        isSubmitted: true,
        values: allValue,
        filesToRemove: [],
        oldSign1: removeSignOne || "",
        oldSign2: removeSignTwo || "",
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      filesList &&
        filesList.map((item) => {
          formData.append("attachments", item);
        });
      signOne &&
        formData.append(
          "signature1",
          signOne,
          `signature1-${formId}-${new Date().toISOString()}.png`
        );
      signTwo &&
        formData.append(
          "signature2",
          signTwo,
          `signature2-${formId}-${new Date().toISOString()}.png`
        );
      axiosInstance
        .put(`/schedules/form-submition/${formId}`, formData)
        .then((res) => {
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            CloseEditForm(formId);
          } else {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
            setShowErrorFeild(true);
            setErrorMessage(res.data?.data || "Network error.");
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    },
  });

//     const [formValue, setFormValue] = useState([]);
  
// function deleteRow(titleIndex, fieldIndex, rowIndex) {
//   // Find the field in allValue
//   const fieldId = formValue[titleIndex]?.fields[fieldIndex]?.id;
//   if (!fieldId) return;

//   const updatedAllValue = allValue.map(item => {
//     if (item.id === fieldId && Array.isArray(item.value)) {
//       // Create a new array without the deleted row
//       const newValue = [...item.value];
//       newValue.splice(rowIndex, 1);
//       return { ...item, value: newValue };
//     }
//     return item;
//   });
//    console.log('Deleting row:', { titleIndex, fieldIndex, rowIndex });
//   console.log('Current formValue:', formValue);
//   console.log('Current allValue:', allValue);

//   setAllValue(updatedAllValue);

//   // Also update formValue for UI consistency
//   setFormValue(prev => {
//     const newFormValue = JSON.parse(JSON.stringify(prev));
//     const field = newFormValue[titleIndex]?.fields[fieldIndex];
//     if (field && Array.isArray(field.value)) {
//       field.value.splice(rowIndex, 1);
//     }
//     return newFormValue;
//   });
// }

  function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: allValue,
      filesToRemove: [],
      oldSign1: removeSignOne || "",
      oldSign2: removeSignTwo || "",
    };
    let formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));
    filesList &&
      filesList.map((item) => {
        formData.append("attachments", item);
      });
    signOne &&
      formData.append(
        "signature1",
        signOne,
        `signature1-${formId}-${new Date().toISOString()}.png`
      );
    signTwo &&
      formData.append(
        "signature2",
        signTwo,
        `signature2-${formId}-${new Date().toISOString()}.png`
      );

    axiosInstance
      .put(`/schedules/form-submition/${formId}`, formData)
      .then((res) => {
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      });
  }

  async function CloseEditForm(formId) {
    try {
      const res = await axiosInstance.put(`/schedules/close-form/${formId}`);
      if (res?.data?.status) {
        setEditModeIndex(null);
        fetchTasks(formId);
        return true;
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data?.msg || "Network error.",
        });
        return false;
      }
    } catch (error) {
      toast.open({
        type: "error",
        message: "Error",
        description: error?.response?.data?.msg || "Network error.",
      });
      return false;
    }
  }

  async function OpenEditForm(formId, workingUser) {
    if (workingUser) {
      CloseEditForm(formId);
    } else {
      try {
        const res = await axiosInstance.put(`/schedules/open-form/${formId}`);
        if (res?.data?.status) {
          fetchTasks(formId);
          setEditModeIndex(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      } catch (error) {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      }
    }
  }

  // Handle navigation with confirmation
  const handleNavigation = (targetPath) => {
    if (editModeIndex === scheduleViewId) {
      // Form is open, show confirmation
      setPendingNavigation(targetPath);
      setShowNavigationConfirm(true);
    } else {
      // Form is not open, allow navigation
      navigate(targetPath);
    }
  };

  // Handle confirmation to close form and navigate
  const confirmNavigation = async () => {
    setIsClosingForm(true);
    const success = await CloseEditForm(scheduleViewId);
    setIsClosingForm(false);

    if (success) {
      setShowNavigationConfirm(false);
      if (pendingNavigation !== null) {
        if (typeof pendingNavigation === "object" && pendingNavigation.to) {
          // Navigation with options
          navigate(pendingNavigation.to, pendingNavigation.options);
        } else {
          // Simple path navigation
          navigate(pendingNavigation);
        }
      }
    }
  };

  // Handle cancellation of navigation
  const cancelNavigation = () => {
    setShowNavigationConfirm(false);
    setPendingNavigation(null);
  };

  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/schedules/check-submitted/${scheduleViewId}`
      );
      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);
  const [otpEnable, setOtpEnable] = useState(false);

  // Check OTP enable status
  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        setOtpEnable(false);
      }
    } catch (error) {
      setOtpEnable(false);
    }
  };

  useEffect(() => {
    checkOtpEnable();
  }, [scheduleViewId]);

  useEffect(() => {
    if (allForm?.signature1?.file) {
      setRemoveSignOne(allForm?.signature1?.file);
    }
    if (allForm?.signature2?.file) {
      setRemoveSignTwo(allForm?.signature2?.file);
    }
  }, [allForm]);


   const [loadingEditId, setLoadingEditId] = useState(null);

const handleEditClick = async (id, user) => {
  try {
    setLoadingEditId(id);

    if (editModeIndex === id) {
      // Already in edit mode → close form
      await CloseEditForm(id);
      setEditModeIndex(null); // force reset to red
    } else {
      // Not in edit mode → open form
      await OpenEditForm(id, user);
      setEditModeIndex(id); // force green
    }

  } finally {
    setLoadingEditId(null);
  }
};

  return (
    <>
      <div className="py-4 px-4 overflow-hidden h-[calc(100vh-80px)] flex flex-col">
        <div className="sm:flex justify-between w-full mb-4">
          <Breadcrumb
            items={[
              {
                name: "Form",
                link: `/inspection/schedule/newform/${scheduleViewId}`,
              },
              {
                name: form?.formName || "Form Details",
              },
            ]}
            onNavigate={handleNavigation}
          />
          {/* <div className="flex gap-2 justify-end">
            {GetAccess("inspection_schedule_form_edit") &&
              (GetRole() || isSubmittted) && (
                <span
                  onClick={() =>
                    OpenEditForm(scheduleViewId, form?.workingUser)
                  }
                  className={`cursor-pointer mr-4 rounded-md p-1 border 
                  ${
                    editModeIndex === scheduleViewId
                      ? "bg-green-100 border-green-500"
                      : "bg-red-100 border-red-500"
                  }`}
                >
                  <EditIcon
                    color={editModeIndex === scheduleViewId ? "green" : "red"}
                    height={16}
                  />
                </span>
              )}
            <BackButton onClick={() => handleNavigation(-1)} />
          </div> */}
            <div className="flex gap-2 justify-end">
      {GetAccess("inspection_schedule_form_edit") && (GetRole() || isSubmittted) && (
        <span
          onClick={() => handleEditClick(scheduleViewId, form?.workingUser)}
          className={`cursor-pointer mr-4 rounded-md p-1 border 
            ${
              editModeIndex === scheduleViewId
                ? "bg-green-100 border-green-500"
                : "bg-red-100 border-red-500"
            }`}
        >
          {loadingEditId === scheduleViewId ? (
            // Loader while API is running
            <div className="w-4 h-4 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          ) : (
            // Normal Edit Icon
            <EditIcon
              color={editModeIndex === scheduleViewId ? "green" : "red"}
              height={16}
            />
          )}
        </span>
      )}
      <BackButton onClick={() => handleNavigation(-1)} />
    </div>
          
        </div>
        <div className="bg-white flex-1 overflow-y-auto rounded-md ">
          <form onSubmit={formik.handleSubmit}>
            <NewCommonDynamicForm
              formData={allForm?.titles || []}
              formik={formik}
              allValue={allValue}
              setAllValue={setAllValue}
              SaveFormData={SaveFormData}
              // deleteRow={deleteRow}

              editModeIndex={!!editModeIndex}
              FileAttachment={setFileList}
              hasSign={false}
              hasSignOne={false}
              hasSignTwo={false}
              SignOne="Inspector"
              SignTwo="Client"
              setSignFunOne={setSignOne}
              setSignFunTwo={setSignTwo}
              allData={allForm}
              setFileRemoveList={setFileRemoveList}
              fileRemoveList={fileRemoveList}
              setRemoveSignOne={setRemoveSignOne}
              setRemoveSignTwo={setRemoveSignTwo}
              setAllForm={setAllForm}
            />
          </form>
        </div>

        {/* Navigation Confirmation Modal */}
        {showNavigationConfirm && (
          <ModalContainer
            visiable={showNavigationConfirm}
            title="Form is Open"
            content={
              <div>
                <p>
                  The form is currently open for editing. Do you want to close
                  it before leaving?
                </p>
              </div>
            }
            handleClick={confirmNavigation}
            closeModal={cancelNavigation}
            isLoading={isClosingForm}
            confirmText="Yes, Close Form"
            cancelText="Cancel"
          />
        )}

        {showErrorFeild && (
          <ModalContainer
            closeModal={() => setShowErrorFeild(false)}
            visiable={showErrorFeild}
            title=""
            hasButton={false}
            content={
              <div className="max-w-[65vw] max-h-[90vh] min-h-[30vh] 2xl:min-w-[45vw]">
                <div className="w-full h-7 mb-2 flex justify-between items-center">
                  <p className="font-semibold text-sm">Fields to be checked</p>
                  <div className="flex gap-4 items-center">
                    <button
                      className="text-white bg-red-600"
                      onClick={() => {
                        setShowErrorFeild(false);
                        setErrorMessage("");
                      }}
                    >
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="w-full max-h-[calc(90vh-32px)] overflow-y-auto">
                  <pre>{ErrorMessage}</pre>
                </div>
              </div>
            }
          />
        )}
      </div>
    </>
  );
}

export default FormOpen;
